import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {  onMounted,watch } from 'vue'


import { useRoute } from 'vue-router';
 

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
 
watch(() => route.fullPath, (newPath, oldPath) => {
  // 路由变化时的处理逻辑
  // console.log('路由已变更：', oldPath, '->', newPath);


  // if (window._czc) {
  //         let location = window.location;
  //         let contentUrl = location.pathname + location.hash;
  //         let refererUrl = "/";
  //         window._czc.push(["_trackPageview", contentUrl, refererUrl]);

  //         console.log('已发送页面访问数据');
          
  //       }



});


onMounted(()=>{
  const script = document.createElement("script");
        script.src =
          "https://s9.cnzz.com/z.js?id=1281374417&async=1";   
        script.language = "JavaScript";
        document.body.appendChild(script);
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})